<button [disabled]="disabled"
    class="w-full focus:outline-none text-white text-sm py-3 px-6 rounded-md hover:shadow-lg"
    [ngClass]="status === 'confirm' ? 'bg-blue-500 hover:bg-blue-600' : 'bg-red-500 hover:bg-red-600'" >
    <ng-content></ng-content>
</button>
